import {
  CssBaseline,
  ThemeProvider as MUIThemeProvider,
  createTheme,
} from '@mui/material';
import { useMemo } from 'react';

import { createComponents } from '../lib/createComponents';
import { createPalette } from '../lib/createPalette';
import { createShadows } from '../lib/createShadows';
import { createTypography } from '../lib/createTypography';

export const ThemeProvider = ({ children }: { children: React.ReactNode }) => {
  // TODO: снять комменты после добавления тёмной темы
  // const { mode } = useColorScheme();
  // const _mode = !mode || mode === 'system' ? 'light' : mode;

  const _mode = 'light';

  const theme = useMemo(() => {
    return createTheme({
      cssVariables: {
        cssVarPrefix: 'ucr',
        colorSchemeSelector: '.mode-%s',
      },
      spacing: 4,

      ...createPalette(),
      ...createTypography(),
      ...createShadows(),

      ...createComponents({
        mode: _mode,
      }),
    });
  }, [_mode]);

  return (
    <MUIThemeProvider theme={theme} defaultMode='light'>
      <CssBaseline />
      {children}
    </MUIThemeProvider>
  );
};
